import { render, staticRenderFns } from "./modules5.vue?vue&type=template&id=d431490e&scoped=true"
import script from "./modules5.vue?vue&type=script&lang=js"
export * from "./modules5.vue?vue&type=script&lang=js"
import style0 from "./modules5.vue?vue&type=style&index=0&id=d431490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d431490e",
  null
  
)

export default component.exports